import Component from '../core/Component'
import { EMITS as SLIDER_EMITS } from './Slider'
import { EMITS as MENU_EMITS } from './Menu'

export default class ReachUs extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            slider: null,
            menu: null,
            indicator: null,
        }

        this.menu = null
        this.slider = null
    }

    prepare() {
        if (this.ref.menu) {
            this.menu = Component.getFromElement(this.ref.menu)
            this.menu.on(MENU_EMITS.LINK_CLICKED, this.handleMenuLinkClicked)
        }

        if (this.ref.slider) {
            this.slider = Component.getFromElement(this.ref.slider)
            this.slider.on(SLIDER_EMITS.SELECTED, this.handleSliderSelected)
        }
    }

    handleSliderSelected = ({ index }) => {
        this.menu.select(index)
        this.updateIndicator()
    }

    handleMenuLinkClicked = ({ index }) => {
        this.slider.select(index)
    }

    updateIndicator() {
        if (!this.menu.flickity) {
            const link =  this.menu.getLinks()[this.menu.getActiveLinkIndex()]
            const width = link.offsetWidth
            const left = link.offsetLeft

            this.ref.indicator.style.width = `${width}px`
            this.ref.indicator.style.transform = `translate3d(${left}px,0,0)`
        }
    }



}